import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import SectionHeader from './SectionHeader';
import PhotoUploadBox from './PhotoUploadBox';

export default function DriverDetailsSection({
    formData,
    handleInputChange,
    handleImageUpload,
    hasError,
    getErrorMessage,
    inputStyles,
    redAsteriskStyle
}) {
    return (
        <Box >
            <SectionHeader title="Driver Details" />
            <Box sx={{ p: 3 }}>
                <Grid container spacing={3}>
                    {/* Left column */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Full Name <span style={redAsteriskStyle}>*</span>
                            </Typography>
                            <TextField
                                required
                                fullWidth
                                value={formData.fullName}
                                onChange={handleInputChange}
                                id="fullName"
                                placeholder="Enter your full name"
                                name="fullName"
                                variant="outlined"
                                sx={inputStyles}
                                error={hasError('fullName')}
                                helperText={getErrorMessage('fullName')}
                                InputProps={{
                                    required: false
                                }}
                            />
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Driving License ID <span style={redAsteriskStyle}>*</span>
                            </Typography>
                            <TextField
                                required
                                fullWidth
                                value={formData.drivingLicenseId}
                                onChange={handleInputChange}
                                id="drivingLicenseId"
                                placeholder="Enter your driving license ID"
                                name="drivingLicenseId"
                                variant="outlined"
                                sx={inputStyles}
                                error={hasError('drivingLicenseId')}
                                helperText={getErrorMessage('drivingLicenseId')}
                                InputProps={{
                                    required: false
                                }}
                            />
                        </Box>

                        <Box>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Email
                            </Typography>
                            <TextField
                                fullWidth
                                value={formData.email}
                                onChange={handleInputChange}
                                id="email"
                                placeholder="Enter your email address"
                                name="email"
                                type="email"
                                variant="outlined"
                                sx={inputStyles}
                                error={hasError('email')}
                                helperText={getErrorMessage('email')}
                            />
                        </Box>
                    </Grid>

                    {/* Middle column */}
                    <Grid item xs={12} md={4}>
                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Driver ID <span style={redAsteriskStyle}>*</span>
                            </Typography>
                            <TextField
                                required
                                fullWidth
                                value={formData.driverId}
                                onChange={handleInputChange}
                                id="driverId"
                                placeholder="Enter your driver ID"
                                name="driverId"
                                variant="outlined"
                                sx={inputStyles}
                                error={hasError('driverId')}
                                helperText={getErrorMessage('driverId')}
                                InputProps={{
                                    required: false
                                }}
                            />
                        </Box>

                        <Box sx={{ mb: 2 }}>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Phone Number
                            </Typography>
                            <TextField
                                fullWidth
                                value={formData.phoneNumber}
                                onChange={handleInputChange}
                                id="phoneNumber"
                                placeholder="Enter your phone number"
                                name="phoneNumber"
                                variant="outlined"
                                sx={inputStyles}
                                error={hasError('phoneNumber')}
                                helperText={getErrorMessage('phoneNumber')}
                            />
                        </Box>

                        <Box>
                            <Typography variant="subtitle2" sx={{ mb: 1 }}>
                                Date Of Birth
                            </Typography>
                            <TextField
                                fullWidth
                                value={formData.dateOfBirth}
                                onChange={handleInputChange}
                                id="dateOfBirth"
                                placeholder="DD/MM/YYYY"
                                name="dateOfBirth"
                                type="date"
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                                sx={inputStyles}
                            />
                        </Box>
                    </Grid>

                    {/* Photo upload column */}
                    <Grid item xs={12} md={4}>
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%'
                            }}
                        >
                            <PhotoUploadBox onImageUpload={handleImageUpload} />
                        </Box>
                    </Grid>

                    {/* More Details full width row */}
                    <Grid item xs={12}>
                        <Typography variant="subtitle2" sx={{ mb: 1 }}>
                            More Details
                        </Typography>
                        <TextField
                            fullWidth
                            value={formData.moreDetails}
                            onChange={handleInputChange}
                            id="moreDetails"
                            placeholder="Add any additional information"
                            name="moreDetails"
                            variant="outlined"
                            rows={2}
                            sx={inputStyles}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}
